<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-footer
      :no-data-text="$t('common.nodata')"
      fixed-header
      class="custom-price-data-table gray10"
      :header-props="{ 'sort-icon': '$sortIcon' }"
    >
      <template v-slot:item.index="{ item }">
        {{ items.indexOf(item) + (pageNo - 1) * pageSize + 1 }}
      </template>

      <template v-slot:item.createdDate="{ item }">
        <span class="font-Regular-12">
          {{ item.createdDate | dateTimeFilter }}
        </span>
      </template>

      <template v-slot:item.source="{ item }">
        <span class="font-Regular-12">
          <template v-if="item.source === 'STOP_LIMIT_CONDITION'">
            {{ $t("preconditionsHistory.stopLimit") }}
          </template>

          <template v-else-if="item.source === 'OCO_CONDITION'">
            {{ $t("preconditionsHistory.ocoStopLimit") }}
          </template>
        </span>
      </template>

      <template v-slot:item.direction="{ item }">
        <span
          :class="[
            'font-Regular-12',
            item.direction === 'BUY' ? 'success--text' : 'error--text'
          ]"
        >
          {{
            item.direction === "BUY"
              ? $t("preconditionsHistory.buy")
              : $t("preconditionsHistory.sell")
          }}
        </span>
      </template>

      <template v-slot:item.activationPrice="{ item }">
        <span class="font-Regular-12">
          {{ item.activationPrice }}
          <!--          <template v-if="item.momentMarketPrice >= item.activationPrice">-->
          <!--            =>-->
          <!--          </template>-->
          <!--          <template v-else> =< </template>-->
        </span>
      </template>

      <template v-slot:item.price="{ item }">
        <span class="font-Regular-12">
          {{ $thousandMask(item.orderPrice) }}
        </span>
      </template>

      <template v-slot:item.amount="{ item }">
        <div class="price-style justify-center">
          <span class="font-Regular-12">{{ $thousandMask(item.amount) }} </span>
          <span v-if="item.symbol" class="font-Regular-12">
            {{ item.symbol.split("/")[0] }}
          </span>
        </div>
      </template>

      <template v-slot:item.status="{ item }">
        <span
          v-if="item.status === 'COMPLETED'"
          class="warning--text font-Regular-12"
        >
          {{ $t("preconditionsHistory.completed") }}
        </span>

        <span
          v-else-if="item.status === 'ERROR' || item.status === 'CANCELED'"
          class="error--text font-Regular-12"
        >
          {{ $t("preconditionsHistory.canceled") }}
        </span>

        <span
          v-if="item.status === 'ORDERED'"
          class="warning--text font-Regular-12"
        >
          {{ $t("preconditionsHistory.ordered") }}
        </span>
      </template>

      <template v-slot:item.operation="{ item }">
        <v-btn
          :loading="detailsBtnLoading === item.id"
          color="primaryX"
          text
          @click="getPreconditionDetails(item.id)"
        >
          {{ $t("preconditionsHistory.details") }}
        </v-btn>
      </template>
    </v-data-table>
    <!--    detail modal-->
    <v-dialog v-model="isModalOpen" width="500">
      <v-card>
        <v-card-title>
          {{ $t("preconditionsHistory.orderDetails") }}
        </v-card-title>
        <v-card-text>
          <div class="font-Regular-14 custom-modal-body pb-5">
            <ul v-if="true" class="preconditionDetailList">
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("preconditionsHistory.time") }}</span
                >
                <span class="font-Regular-12">
                  {{ preconditionDetailsData.createdDate | dateTimeFilter }}
                </span>
              </li>

              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("preconditionsHistory.type") }}
                </span>
                <span class="font-Regular-12">
                  <template
                    v-if="
                      preconditionDetailsData.source === 'STOP_LIMIT_CONDITION'
                    "
                  >
                    {{ $t("preconditionsHistory.stopLimit") }}
                  </template>
                  <template
                    v-else-if="
                      preconditionDetailsData.source === 'OCO_CONDITION'
                    "
                  >
                    {{ $t("preconditionsHistory.ocoStopLimit") }}
                  </template>
                </span>
              </li>
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("preconditionsHistory.pairCoin") }}
                </span>
                <span class="font-Regular-12">
                  {{ preconditionDetailsData.symbol }}
                </span>
              </li>
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("preconditionsHistory.tradeDirection") }}
                </span>
                <span
                  :class="[
                    'font-Regular-12',
                    preconditionDetailsData.direction === 'BUY'
                      ? 'success--text'
                      : 'error--text'
                  ]"
                >
                  {{
                    preconditionDetailsData.direction === "BUY"
                      ? $t("preconditionsHistory.buy")
                      : $t("preconditionsHistory.sell")
                  }}
                </span>
              </li>
              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">{{
                  $t("preconditionsHistory.amount")
                }}</span>

                <div
                  v-if="preconditionDetailsData.symbol"
                  class="price-style justify-center"
                >
                  <span class="font-Regular-12">
                    {{ preconditionDetailsData.amount }}
                  </span>
                  <span class="font-Regular-12">
                    {{
                      preconditionDetailsData.type === "MARKET_PRICE"
                        ? preconditionDetailsData.direction === "BUY"
                          ? preconditionDetailsData.symbol.split("/")[1]
                          : preconditionDetailsData.symbol.split("/")[0]
                        : preconditionDetailsData.symbol.split("/")[0]
                    }}
                  </span>
                </div>
              </li>

              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("preconditionsHistory.activationPrice") }}
                </span>
                <div class="font-Regular-12">
                  {{ preconditionDetailsData.activationPrice }}
                  <span class="font-Regular-16">
                    <!--                    <template-->
                    <!--                      v-if="-->
                    <!--                        preconditionDetailsData.momentMarketPrice >=-->
                    <!--                          preconditionDetailsData.activationPrice-->
                    <!--                      "-->
                    <!--                    >-->
                    <!--                      =>-->
                    <!--                    </template>-->
                    <!--                    <template v-else>-->
                    <!--                      =<-->
                    <!--                    </template>-->
                  </span>
                </div>
              </li>

              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">
                  {{ $t("preconditionsHistory.price") }}
                </span>
                <span class="font-Regular-12">
                  {{ $thousandMask(preconditionDetailsData.orderPrice) }}
                </span>
              </li>

              <li class="d-flex justify-space-between mb-5">
                <span class="font-Regular-12 precondition-detail-title">{{
                  $t("preconditionsHistory.description")
                }}</span>
                <span class="font-Regular-12">
                  {{
                    preconditionDetailsData.errorMessage
                      ? preconditionDetailsData.errorMessage
                      : "-"
                  }}
                </span>
              </li>
            </ul>

            <div class="table-responsive-wrapper">
              <v-data-table
                :headers="preconditionOrdersDetailColumns"
                :items="preconditionOrdersDetailData"
                :no-data-text="$t('common.nodata')"
                hide-default-footer
                class="pa-5"
              >
                <template v-slot:item.time="{ item }">
                  <span class="font-Regular-12">
                    {{ item.time | dateTimeFilter }}
                  </span>
                </template>

                <template v-slot:item.price="{ item }">
                  <span class="font-Regular-12">
                    {{ $thousandMask(item.price) }}
                  </span>
                </template>

                <template v-slot:item.amount="{ item }">
                  <span class="font-Regular-12">
                    {{ $thousandMask(item.amount) }}
                  </span>
                </template>

                <template v-slot:item.turnOver="{ item }">
                  <span class="font-Regular-12">
                    {{ $thousandMask(item.turnover) }}
                  </span>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayjs from "@/utiles/dayjs";
import $thousandMask from "@/mixins/thousandMask";
import { ExchangeService } from "@/services";

export default {
  data() {
    return {
      headers: [
        {
          text: "#",
          value: "index",
          width: "50px",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("preconditionsHistory.time"),
          value: "createdDate",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("preconditionsHistory.pairCoin"),
          value: "symbol",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("preconditionsHistory.orderType"),
          value: "source",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("preconditionsHistory.tradeDirection"),
          value: "direction",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("preconditionsHistory.activationPrice"),
          value: "activationPrice",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("preconditionsHistory.price"),
          value: "price",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("preconditionsHistory.amount"),
          value: "amount",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("preconditionsHistory.refCode"),
          value: "trackingCode",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("preconditionsHistory.status"),
          value: "status",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("preconditionsHistory.operation"),
          value: "operation",
          sortable: false,
          align: "center"
        }
      ],
      preconditionOrdersDetailColumns: [
        {
          text: this.$t("preconditionsHistory.amount"),
          value: "amount",
          width: "180",
          align: "center"
        },
        {
          text: this.$t("preconditionsHistory.price"),
          value: "price",
          width: "180",
          align: "center"
        },
        {
          text: this.$t("preconditionsHistory.time"),
          value: "time",
          width: "180",
          align: "center"
        },
        {
          text: this.$t("preconditionsHistory.turnOver"),
          value: "turnOver",
          width: "180",
          align: "center"
        }
      ],
      cancelOrderModal: false,
      isOrderDetailModalOpen: false,
      detailsBtnLoading: null,
      preconditionDetailsData: [],
      preconditionOrdersDetailData: [],
      isModalOpen: false
    };
  },
  props: ["items", "pageNo", "pageSize"],
  mixins: [$thousandMask],
  filters: {
    dateTimeFilter(date) {
      return (
        dayjs(date).format("HH:mm") + " - " + dayjs(date).format("YYYY/MM/DD")
      );
    }
  },
  methods: {
    getPreconditionDetails(preconditionId) {
      if (this.detailsBtnLoading !== null) return;
      this.detailsBtnLoading = preconditionId;
      ExchangeService.getPreconditionOrderDetailByID(preconditionId)
        .then(response => {
          this.preconditionDetailsData = response.data.data.precondition;
          this.preconditionOrdersDetailData = response.data.data.orders;
          this.isModalOpen = true;
        })
        .finally(() => {
          this.detailsBtnLoading = null;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
